import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { DotLoader } from '../../../../../common/components/Loader/Loader';

const SummaryPremiumRow = ({ label, value, isUpdating }) => {
  if (!value) {
    return null;
  }
  return (
    <Row>
      <Col md={8}>{label}</Col>
      <Col md={4} className="sidebar-summary-premium">
        {isUpdating ? <DotLoader /> : value}
      </Col>
    </Row>
  );
};

export default SummaryPremiumRow;
